<template>
  <div class="home">
    <Header :present-page="presentPage" />
    <a-row class="a-row">
      <!-- <a-col
        span="3"
        @click="goto('/system/configure/sensor')"
      >
        <img src="@/assets/images/system/1.png">
        <p>设备配置</p>
        <span>线路、桥梁、产品、设备配置</span>
      </a-col> -->
      <a-col
        span="3"
        offset="1"
        @click="goto('/system/configure/basics')"
      >
        <img src="@/assets/images/system/2.png">
        <p>后台配置</p>
        <span>公司名称、系统名称、版权信息 登录背景配置</span>
      </a-col>
    </a-row>
  </div>
</template>

<script>
// @ is an alias to /src
import Header from "@/components/header/header.vue";

export default {
  name: "Configure",
  components: {
    Header,
  },
  data() {
    return {
      presentPage: '',
    }
  },
  mounted() {
    this.presentPage = this.$route.query.name
  },
  methods: {
    goto(path) {
      this.$router.push({ path: path }, () => { }).catch(res => {
        console.log(res)
      });
    }
  }
};
</script>
<style scoped>
.a-row {
  margin: 30px;
}
.a-row .ant-col {
  padding: 14px;
  background: #fff;
  border-radius: 5px;
}
.a-row img {
  width: 52px;
}
.a-row p {
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #008fff;
}
.a-row span {
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #808080;
}
</style>